// extracted by mini-css-extract-plugin
export default {"group":"Group_group__cvjxw","active":"Group_active__D3A2Z","head":"Group_head__-aJ4-","menu":"Group_menu__d8qNW","link":"Group_link__siN1e"};